import { SEOHead } from "@/components/seo/SEOHead";
import { useRoOnlyGuard } from '@/hooks/useRoOnlyGuard';

export default function MentiuniLegale() {
  const __roBlocked = useRoOnlyGuard();
  return (
    <>
      <SEOHead
        title="Mențiuni Legale - ROAutoMarket"
        description="Informații despre operatorul platformei roautomarket.ro."
        canonicalPath="/mentiuni-legale"
      />
      <div className="container mx-auto px-4 py-10 max-w-4xl">
        <div className="surface-dark band-bleed -mt-10 mb-8 py-6"><h1 className="text-3xl md:text-4xl font-bold">Mențiuni Legale</h1></div>
        <div className="prose prose-neutral dark:prose-invert max-w-none space-y-6">
          <p>
            Platforma <strong>roautomarket.ro</strong> este operată de un comerciant individual înregistrat în
            Regatul Unit, care prestează servicii transfrontaliere către utilizatori din România și Uniunea Europeană.
            Conform Legii 365/2002 (RO) și UK e-Commerce Regulations 2002, oferim mai jos informațiile de identificare.
          </p>

          <section>
            <h2 className="text-2xl font-semibold mb-3">Operatorul site-ului</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li><strong>Nume comercial:</strong> RO Auto Market</li>
              <li><strong>Operator:</strong> Vladimir Tudor</li>
              <li><strong>Formă juridică:</strong> Sole Trader (comerciant individual înregistrat în UK)</li>
              <li><strong>Țara de înregistrare:</strong> United Kingdom</li>
              <li><strong>UTR (HMRC):</strong> 9810367572</li>
              <li><strong>Sediu / adresă de corespondență:</strong> 62 Clarkson Court, Hatfield, AL10 9GW, United Kingdom</li>
              <li><strong>Autoritate fiscală:</strong> HM Revenue &amp; Customs (HMRC), Regatul Unit</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-3">Contact</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li><strong>Email:</strong> <a href="mailto:contact@roautomarket.ro" className="text-primary hover:underline">contact@roautomarket.ro</a></li>
              <li><strong>Telefon UK / WhatsApp:</strong> <a href="https://wa.me/447585318863" className="text-primary hover:underline">+44 7585 318863</a></li>
              <li><strong>Telefon RO / WhatsApp:</strong> <a href="https://wa.me/40732963134" className="text-primary hover:underline">+40 732 963 134</a></li>
              <li><strong>Site web:</strong> <a href="https://roautomarket.ro" className="text-primary hover:underline">roautomarket.ro</a></li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-3">Protecția datelor</h2>
            <p>
              Operatorul este stabilit în Regatul Unit, deci se aplică <strong>UK GDPR</strong> și <strong>Data Protection Act 2018</strong>.
              Pentru utilizatorii din Uniunea Europeană se aplică suplimentar <strong>Regulamentul (UE) 2016/679 (GDPR)</strong>,
              în temeiul art. 3(2) – ofertă de servicii pentru persoane vizate din UE.
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li><strong>Autoritate principală (UK):</strong> Information Commissioner's Office (ICO) – <a href="https://ico.org.uk" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">ico.org.uk</a></li>
              <li><strong>Autoritate pentru utilizatorii din România:</strong> ANSPDCP – <a href="https://www.dataprotection.ro" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">dataprotection.ro</a></li>
              <li><strong>Reprezentant UE (GDPR art. 27):</strong> în curs de numire. Până la finalizare, cererile utilizatorilor din UE pot fi trimise direct la <a href="mailto:contact@roautomarket.ro" className="text-primary hover:underline">contact@roautomarket.ro</a>.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-3">Găzduire (hosting)</h2>
            <p>
              Aplicația este găzduită pe infrastructura <strong>Lovable</strong> (lovable.dev), iar baza de date și
              autentificarea sunt asigurate de <strong>Supabase</strong> (supabase.com), cu servere în Uniunea Europeană.
              Plățile sunt procesate de <strong>Stripe</strong>.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-3">Proprietate intelectuală</h2>
            <p>
              Toate elementele site-ului (texte, logo, design, cod sursă) sunt proprietatea operatorului sau a
              partenerilor săi și sunt protejate de legislația în vigoare. Reproducerea fără acord scris este interzisă.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-3">Documente conexe</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li><a href="/termeni-si-conditii" className="text-primary hover:underline">Termeni și Condiții</a></li>
              <li><a href="/politica-de-confidentialitate" className="text-primary hover:underline">Politica de Confidențialitate</a></li>
              <li><a href="/politica-cookies" className="text-primary hover:underline">Politica de Cookies</a></li>
              <li><a href="/accesibilitate" className="text-primary hover:underline">Declarație de Accesibilitate</a></li>
            </ul>
          </section>
        </div>
      </div>
    </>
  );
}
